export default __webpack_public_path__ + "static/Prometheus_Pipeline-a8534bccc844f12bdd18643efa2b965b.png";